function defineFunction(handler) {
  return handler;
}
function defineEvent(...listeners) {
  return { [Symbol.onexus.event]: listeners };
}
const createEventTopic = defineEvent;
const namespace = Symbol("nexus-namespace");
function defineNamespace(implementation) {
  return { ...implementation, [namespace]: true };
}
const otto = window.otto ?? {};
export {
  createEventTopic,
  defineEvent,
  defineFunction,
  defineNamespace,
  otto
};
/*                              */
